// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.m_e4d36c9b {
  min-width: calc(12.5rem * var(--mantine-scale));
  background-color: var(--mantine-color-body);
  box-shadow: var(--mantine-shadow-md);
  border-radius: var(--mantine-radius-default);
}

  :where([data-mantine-color-scheme='light']) .m_e4d36c9b {
    border: 1px solid var(--mantine-color-gray-3);
}

  :where([data-mantine-color-scheme='dark']) .m_e4d36c9b {
    border: 1px solid var(--mantine-color-dark-4);
}

.m_7f4bcb19 {
  padding: var(--mantine-spacing-xs) var(--mantine-spacing-md);
  font-size: var(--mantine-font-size-md);
  font-weight: 500;
  color: var(--mantine-color-bright);
}

.m_3de554dd {
  padding: var(--mantine-spacing-sm) var(--mantine-spacing-md);
  padding-top: 0;
}

.m_e4d36c9b:where([data-type='radial']) :where(.m_3de554dd) {
    padding-top: var(--mantine-spacing-sm);
  }

.m_3de8964e {
  font-size: var(--mantine-font-size-sm);
  display: flex;
  justify-content: space-between;
}

.m_3de8964e:where(.m_3de8964e + .m_3de8964e) {
    margin-top: calc(var(--mantine-spacing-sm) / 2);
  }

.m_3de8964e[data-type='scatter'] .m_b30369b5 {
    display: none;
  }

.m_50186d10 {
  display: flex;
  align-items: center;
  gap: var(--mantine-spacing-sm);
  margin-inline-end: var(--mantine-spacing-xl);
}

.m_501dadf9 {
  color: var(--mantine-color-text);
  font-size: var(--mantine-font-size-sm);
}

.m_50192318 {
  color: var(--mantine-color-bright);
}

.m_847eaf {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  height: 100%;
}

  .m_847eaf:where([data-centered]) {
    justify-content: center;
  }

  .m_847eaf:where([data-position='top']) {
    padding-bottom: var(--mantine-spacing-md);
  }

  .m_847eaf:where([data-position='bottom']) {
    padding-top: var(--mantine-spacing-md);
  }

.m_17da7e62 {
  display: flex;
  align-items: center;
  gap: calc(0.4375rem * var(--mantine-scale));
  padding: 7px var(--mantine-spacing-xs);
  border-radius: var(--mantine-radius-default);
  line-height: 1;
}

@media (hover: hover) {
    :where([data-mantine-color-scheme='light']) .m_17da7e62:where(:hover) {
      background-color: var(--mantine-color-gray-0);
  }

    :where([data-mantine-color-scheme='dark']) .m_17da7e62:where(:hover) {
      background-color: var(--mantine-color-dark-5);
  }
}

@media (hover: none) {
    :where([data-mantine-color-scheme='light']) .m_17da7e62:where(:active) {
      background-color: var(--mantine-color-gray-0);
  }

    :where([data-mantine-color-scheme='dark']) .m_17da7e62:where(:active) {
      background-color: var(--mantine-color-dark-5);
  }
}

.m_17da7e62[data-without-color] .m_6e236e21 {
    display: none;
  }

.m_8ff56c0d {
  font-size: var(--mantine-font-size-sm);
  margin: 0;
  padding: 0;
}

.m_a50f3e58 {
  display: block;
  width: 100%;
}

  .m_a50f3e58 svg {
    overflow: visible;
  }

  :where([data-mantine-color-scheme='light']) .m_a50f3e58 {
    --chart-grid-color: rgba(173, 181, 189, 0.6);
    --chart-cursor-fill: rgba(173, 181, 189, 0.15);
}

  :where([data-mantine-color-scheme='dark']) .m_a50f3e58 {
    --chart-cursor-fill: rgba(105, 105, 105, 0.15);
    --chart-grid-color: rgba(105, 105, 105, 0.6);
}

  .m_a50f3e58 :where(text) {
    font-family: var(--mantine-font-family);
    color: var(--chart-text-color, var(--mantine-color-dimmed));
  }

.m_af9188cb {
  height: 100%;
  width: 100%;
}

.m_a50a48bc {
  stroke: var(--chart-grid-color);
}

.m_a507a517 {
  color: var(--chart-grid-color);
}

.m_2293801d {
  color: var(--chart-text-color, var(--mantine-color-dimmed));
}

.m_92b296cd {
  min-width: calc(12.5rem * var(--mantine-scale));
  background-color: var(--mantine-color-body);
  box-shadow: var(--mantine-shadow-md);
  border-radius: var(--mantine-radius-default);
  padding: var(--mantine-spacing-sm);
}

:where([data-mantine-color-scheme='light']) .m_92b296cd {
    border: 1px solid var(--mantine-color-gray-3);
}

:where([data-mantine-color-scheme='dark']) .m_92b296cd {
    border: 1px solid var(--mantine-color-dark-4);
}

.m_a410e613 {
  min-height: var(--chart-size, auto);
  height: var(--chart-size, auto);
  width: var(--chart-size, auto);
  min-width: var(--chart-size, auto);
}

  .m_a410e613 :where(*) {
    outline: 0;
  }

.m_ddb0bfe3 {
  fill: var(--mantine-color-text);
  font-size: var(--mantine-font-size-sm);
}

.m_cd8943fd {
  min-height: var(--chart-size, auto);
  height: var(--chart-size, auto);
  width: var(--chart-size, auto);
  min-width: var(--chart-size, auto);
}

  .m_cd8943fd :where(*) {
    outline: 0;
  }

.m_e3441f39 {
  fill: var(--mantine-color-white);
  font-size: var(--mantine-font-size-xs);
}

:where([data-mantine-color-scheme='light']) .m_1f271cf7 {
    --chart-grid-color: rgba(173, 181, 189, 0.6);
    --chart-text-color: var(--mantine-color-gray-7);
}
  :where([data-mantine-color-scheme='dark']) .m_1f271cf7 {
    --chart-grid-color: rgba(105, 105, 105, 0.6);
    --chart-text-color: var(--mantine-color-dark-1);
}

  .m_1f271cf7 :where(text) {
    font-size: var(--mantine-font-size-xs);
    fill: var(--chart-text-color, var(--mantine-color-dimmed));
    -webkit-user-select: none;
            user-select: none;
  }

.m_cf06f58c {
  height: 100%;
  width: 100%;
}
`, "",{"version":3,"sources":["webpack://./node_modules/@mantine/charts/styles.css"],"names":[],"mappings":"AAAA;EACE,+CAA+C;EAC/C,2CAA2C;EAC3C,oCAAoC;EACpC,4CAA4C;AAC9C;;EAEE;IACE,6CAA6C;AACjD;;EAEE;IACE,6CAA6C;AACjD;;AAEA;EACE,4DAA4D;EAC5D,sCAAsC;EACtC,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,4DAA4D;EAC5D,cAAc;AAChB;;AAEA;IACI,sCAAsC;EACxC;;AAEF;EACE,sCAAsC;EACtC,aAAa;EACb,8BAA8B;AAChC;;AAEA;IACI,+CAA+C;EACjD;;AAEF;IACI,aAAa;EACf;;AAEF;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,4CAA4C;AAC9C;;AAEA;EACE,gCAAgC;EAChC,sCAAsC;AACxC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;AACd;;EAEE;IACE,uBAAuB;EACzB;;EAEA;IACE,yCAAyC;EAC3C;;EAEA;IACE,sCAAsC;EACxC;;AAEF;EACE,aAAa;EACb,mBAAmB;EACnB,2CAA2C;EAC3C,sCAAsC;EACtC,4CAA4C;EAC5C,cAAc;AAChB;;AAEA;IACI;MACE,6CAA6C;EACjD;;IAEE;MACE,6CAA6C;EACjD;AACF;;AAEA;IACI;MACE,6CAA6C;EACjD;;IAEE;MACE,6CAA6C;EACjD;AACF;;AAEA;IACI,aAAa;EACf;;AAEF;EACE,sCAAsC;EACtC,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;EAEE;IACE,iBAAiB;EACnB;;EAEA;IACE,4CAA4C;IAC5C,8CAA8C;AAClD;;EAEE;IACE,8CAA8C;IAC9C,4CAA4C;AAChD;;EAEE;IACE,uCAAuC;IACvC,2DAA2D;EAC7D;;AAEF;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,2DAA2D;AAC7D;;AAEA;EACE,+CAA+C;EAC/C,2CAA2C;EAC3C,oCAAoC;EACpC,4CAA4C;EAC5C,kCAAkC;AACpC;;AAEA;IACI,6CAA6C;AACjD;;AAEA;IACI,6CAA6C;AACjD;;AAEA;EACE,mCAAmC;EACnC,+BAA+B;EAC/B,8BAA8B;EAC9B,kCAAkC;AACpC;;EAEE;IACE,UAAU;EACZ;;AAEF;EACE,+BAA+B;EAC/B,sCAAsC;AACxC;;AAEA;EACE,mCAAmC;EACnC,+BAA+B;EAC/B,8BAA8B;EAC9B,kCAAkC;AACpC;;EAEE;IACE,UAAU;EACZ;;AAEF;EACE,gCAAgC;EAChC,sCAAsC;AACxC;;AAEA;IACI,4CAA4C;IAC5C,+CAA+C;AACnD;EACE;IACE,4CAA4C;IAC5C,+CAA+C;AACnD;;EAEE;IACE,sCAAsC;IACtC,0DAA0D;IAC1D,yBAAiB;YAAjB,iBAAiB;EACnB;;AAEF;EACE,YAAY;EACZ,WAAW;AACb","sourcesContent":[".m_e4d36c9b {\n  min-width: calc(12.5rem * var(--mantine-scale));\n  background-color: var(--mantine-color-body);\n  box-shadow: var(--mantine-shadow-md);\n  border-radius: var(--mantine-radius-default);\n}\n\n  :where([data-mantine-color-scheme='light']) .m_e4d36c9b {\n    border: 1px solid var(--mantine-color-gray-3);\n}\n\n  :where([data-mantine-color-scheme='dark']) .m_e4d36c9b {\n    border: 1px solid var(--mantine-color-dark-4);\n}\n\n.m_7f4bcb19 {\n  padding: var(--mantine-spacing-xs) var(--mantine-spacing-md);\n  font-size: var(--mantine-font-size-md);\n  font-weight: 500;\n  color: var(--mantine-color-bright);\n}\n\n.m_3de554dd {\n  padding: var(--mantine-spacing-sm) var(--mantine-spacing-md);\n  padding-top: 0;\n}\n\n.m_e4d36c9b:where([data-type='radial']) :where(.m_3de554dd) {\n    padding-top: var(--mantine-spacing-sm);\n  }\n\n.m_3de8964e {\n  font-size: var(--mantine-font-size-sm);\n  display: flex;\n  justify-content: space-between;\n}\n\n.m_3de8964e:where(.m_3de8964e + .m_3de8964e) {\n    margin-top: calc(var(--mantine-spacing-sm) / 2);\n  }\n\n.m_3de8964e[data-type='scatter'] .m_b30369b5 {\n    display: none;\n  }\n\n.m_50186d10 {\n  display: flex;\n  align-items: center;\n  gap: var(--mantine-spacing-sm);\n  margin-inline-end: var(--mantine-spacing-xl);\n}\n\n.m_501dadf9 {\n  color: var(--mantine-color-text);\n  font-size: var(--mantine-font-size-sm);\n}\n\n.m_50192318 {\n  color: var(--mantine-color-bright);\n}\n\n.m_847eaf {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: flex-end;\n  height: 100%;\n}\n\n  .m_847eaf:where([data-centered]) {\n    justify-content: center;\n  }\n\n  .m_847eaf:where([data-position='top']) {\n    padding-bottom: var(--mantine-spacing-md);\n  }\n\n  .m_847eaf:where([data-position='bottom']) {\n    padding-top: var(--mantine-spacing-md);\n  }\n\n.m_17da7e62 {\n  display: flex;\n  align-items: center;\n  gap: calc(0.4375rem * var(--mantine-scale));\n  padding: 7px var(--mantine-spacing-xs);\n  border-radius: var(--mantine-radius-default);\n  line-height: 1;\n}\n\n@media (hover: hover) {\n    :where([data-mantine-color-scheme='light']) .m_17da7e62:where(:hover) {\n      background-color: var(--mantine-color-gray-0);\n  }\n\n    :where([data-mantine-color-scheme='dark']) .m_17da7e62:where(:hover) {\n      background-color: var(--mantine-color-dark-5);\n  }\n}\n\n@media (hover: none) {\n    :where([data-mantine-color-scheme='light']) .m_17da7e62:where(:active) {\n      background-color: var(--mantine-color-gray-0);\n  }\n\n    :where([data-mantine-color-scheme='dark']) .m_17da7e62:where(:active) {\n      background-color: var(--mantine-color-dark-5);\n  }\n}\n\n.m_17da7e62[data-without-color] .m_6e236e21 {\n    display: none;\n  }\n\n.m_8ff56c0d {\n  font-size: var(--mantine-font-size-sm);\n  margin: 0;\n  padding: 0;\n}\n\n.m_a50f3e58 {\n  display: block;\n  width: 100%;\n}\n\n  .m_a50f3e58 svg {\n    overflow: visible;\n  }\n\n  :where([data-mantine-color-scheme='light']) .m_a50f3e58 {\n    --chart-grid-color: rgba(173, 181, 189, 0.6);\n    --chart-cursor-fill: rgba(173, 181, 189, 0.15);\n}\n\n  :where([data-mantine-color-scheme='dark']) .m_a50f3e58 {\n    --chart-cursor-fill: rgba(105, 105, 105, 0.15);\n    --chart-grid-color: rgba(105, 105, 105, 0.6);\n}\n\n  .m_a50f3e58 :where(text) {\n    font-family: var(--mantine-font-family);\n    color: var(--chart-text-color, var(--mantine-color-dimmed));\n  }\n\n.m_af9188cb {\n  height: 100%;\n  width: 100%;\n}\n\n.m_a50a48bc {\n  stroke: var(--chart-grid-color);\n}\n\n.m_a507a517 {\n  color: var(--chart-grid-color);\n}\n\n.m_2293801d {\n  color: var(--chart-text-color, var(--mantine-color-dimmed));\n}\n\n.m_92b296cd {\n  min-width: calc(12.5rem * var(--mantine-scale));\n  background-color: var(--mantine-color-body);\n  box-shadow: var(--mantine-shadow-md);\n  border-radius: var(--mantine-radius-default);\n  padding: var(--mantine-spacing-sm);\n}\n\n:where([data-mantine-color-scheme='light']) .m_92b296cd {\n    border: 1px solid var(--mantine-color-gray-3);\n}\n\n:where([data-mantine-color-scheme='dark']) .m_92b296cd {\n    border: 1px solid var(--mantine-color-dark-4);\n}\n\n.m_a410e613 {\n  min-height: var(--chart-size, auto);\n  height: var(--chart-size, auto);\n  width: var(--chart-size, auto);\n  min-width: var(--chart-size, auto);\n}\n\n  .m_a410e613 :where(*) {\n    outline: 0;\n  }\n\n.m_ddb0bfe3 {\n  fill: var(--mantine-color-text);\n  font-size: var(--mantine-font-size-sm);\n}\n\n.m_cd8943fd {\n  min-height: var(--chart-size, auto);\n  height: var(--chart-size, auto);\n  width: var(--chart-size, auto);\n  min-width: var(--chart-size, auto);\n}\n\n  .m_cd8943fd :where(*) {\n    outline: 0;\n  }\n\n.m_e3441f39 {\n  fill: var(--mantine-color-white);\n  font-size: var(--mantine-font-size-xs);\n}\n\n:where([data-mantine-color-scheme='light']) .m_1f271cf7 {\n    --chart-grid-color: rgba(173, 181, 189, 0.6);\n    --chart-text-color: var(--mantine-color-gray-7);\n}\n  :where([data-mantine-color-scheme='dark']) .m_1f271cf7 {\n    --chart-grid-color: rgba(105, 105, 105, 0.6);\n    --chart-text-color: var(--mantine-color-dark-1);\n}\n\n  .m_1f271cf7 :where(text) {\n    font-size: var(--mantine-font-size-xs);\n    fill: var(--chart-text-color, var(--mantine-color-dimmed));\n    user-select: none;\n  }\n\n.m_cf06f58c {\n  height: 100%;\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
